import { Table } from '../../../../components/general/table';
import { LegalProceedingsListProps } from './props';
import { useLegalProceedingsList } from './hook';
import { LEGAL_PROCEEDINGS_DETAIL } from '../../../../../routes/paths';
import { useState } from 'react';

export const LegalProceedingsList = ({
    filters,
    showList = true,
}: LegalProceedingsListProps & { showList?: boolean }) => {
    const { columns, rows, loading } = useLegalProceedingsList(filters);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    if (!showList) {
        return null;
    }

    return (
        <Table
            columns={columns}
            rows={paginatedRows}
            rowCount={rows.length}
            loading={loading}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${LEGAL_PROCEEDINGS_DETAIL}/${item.row.id}`,
                    '_blank'
                )
            }
        />
    );
};
